import React from 'react';

const ClaimsDownloadSVG = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.833 5.5H9.49967V0.5H4.49967V5.5H1.16634L6.99967 12.1667L12.833 5.5ZM0.333008 13.8333H13.6663V15.5H0.333008V13.8333Z"
      fill="#0A7593"
    />
  </svg>
);

const SendSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.01 21L22 12L1.01 3L1 10L16 12L1 14L1.01 21Z"
      className="claims-download-SVG"
    />
  </svg>
);

const ClaimEmailSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7 5H19.3C20.235 5 21 5.765 21 6.7V16.9C21 17.835 20.235 18.6 19.3 18.6H5.7C4.765 18.6 4 17.835 4 16.9L4.0085 6.7C4.0085 5.765 4.765 5 5.7 5ZM12.5 12.65L19.3 8.4V6.7L12.5 10.95L5.7 6.7V8.4L12.5 12.65Z"
      className="claimEmail-SVG"
    />
  </svg>
);

const ViewJobSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M5.36386 2.1223L3.07811 4.42556C2.93167 4.57313 3.03536 4.82554 3.24241 4.82554H5.52816C5.65653 4.8255 5.76058 4.72061 5.76058 4.59122V2.288C5.76058 2.07929 5.51026 1.97478 5.36386 2.1223Z"
        className="claimEmail-SVG"
      />
      <path
        d="M16.1873 14.6047C14.1645 14.6047 12.5189 16.2635 12.5189 18.3025C12.5189 20.3414 14.1645 22.0003 16.1873 22.0003C18.2101 22.0003 19.8558 20.3415 19.8558 18.3025C19.8558 16.2635 18.2101 14.6047 16.1873 14.6047ZM15.6221 16.8595C15.6221 16.5448 15.8752 16.2897 16.1873 16.2897C16.4995 16.2897 16.7526 16.5448 16.7526 16.8595V18.3025C16.7526 18.6172 16.4995 18.8723 16.1873 18.8723C15.8752 18.8723 15.6221 18.6172 15.6221 18.3025V16.8595ZM16.7497 19.8665C16.7478 19.8851 16.7452 19.9037 16.7414 19.922C16.738 19.9402 16.7331 19.9584 16.7279 19.9759C16.7226 19.9937 16.7162 20.0112 16.7094 20.0283C16.7023 20.0454 16.6944 20.0625 16.6857 20.0788C16.6771 20.0952 16.6676 20.1115 16.6574 20.1267C16.6472 20.1423 16.636 20.1575 16.6242 20.1719C16.6125 20.1864 16.6001 20.2004 16.587 20.2133C16.5741 20.2266 16.5602 20.2392 16.5459 20.2513C16.5315 20.2627 16.5165 20.2741 16.501 20.2843C16.486 20.2946 16.4698 20.3041 16.4536 20.3128C16.4373 20.3216 16.4204 20.3295 16.4034 20.3367C16.3865 20.3439 16.3691 20.3501 16.3514 20.3554C16.3337 20.361 16.316 20.3656 16.2979 20.369C16.2798 20.3728 16.2613 20.3759 16.2429 20.3774C16.2245 20.3793 16.206 20.3804 16.1875 20.3804C16.1691 20.3804 16.1502 20.3793 16.1318 20.3774C16.1137 20.3759 16.0952 20.3729 16.0771 20.369C16.0591 20.3656 16.041 20.3611 16.0233 20.3554C16.0055 20.3501 15.9882 20.3439 15.9713 20.3367C15.9543 20.3295 15.9373 20.3215 15.9211 20.3128C15.9049 20.3041 15.8891 20.2946 15.8736 20.2843C15.8582 20.2741 15.8431 20.2627 15.8291 20.2513C15.8144 20.2391 15.8009 20.2266 15.7877 20.2133C15.7745 20.2004 15.762 20.1863 15.7504 20.1719C15.7387 20.1575 15.7278 20.1423 15.7176 20.1267C15.707 20.1115 15.6976 20.0952 15.689 20.0788C15.6803 20.0625 15.6724 20.0454 15.6656 20.0283C15.6585 20.0112 15.652 19.9937 15.6468 19.9759C15.6415 19.9584 15.637 19.9402 15.6332 19.922C15.6294 19.9037 15.6268 19.8851 15.6249 19.8665C15.623 19.8479 15.6222 19.8293 15.6222 19.8107C15.6222 19.7921 15.623 19.7731 15.6249 19.7545C15.6268 19.7362 15.6294 19.7176 15.6332 19.6994C15.637 19.6812 15.6415 19.6629 15.6468 19.6451C15.652 19.6276 15.6585 19.6098 15.6656 19.5927C15.6724 19.5756 15.6803 19.5585 15.689 19.5421C15.6976 19.5258 15.707 19.5099 15.7176 19.4943C15.7278 19.4787 15.7387 19.4635 15.7504 19.4494C15.7621 19.435 15.7745 19.4209 15.7877 19.4077C15.8009 19.3947 15.8145 19.3818 15.8291 19.3701C15.8431 19.3583 15.8582 19.3473 15.8736 19.337C15.8891 19.3268 15.9049 19.3169 15.9211 19.3081C15.9373 19.2994 15.9543 19.2914 15.9713 19.2846C15.9882 19.2774 16.0055 19.2709 16.0233 19.2656C16.041 19.2603 16.059 19.2557 16.0771 19.2519C16.0953 19.2481 16.1137 19.2455 16.1318 19.2436C16.1687 19.2398 16.206 19.2398 16.243 19.2436C16.2614 19.2455 16.2798 19.2481 16.298 19.2519C16.316 19.2557 16.3337 19.2603 16.3515 19.2656C16.3692 19.2709 16.3865 19.2774 16.4035 19.2846C16.4204 19.2914 16.4374 19.2994 16.4536 19.3081C16.4698 19.3169 16.486 19.3268 16.5011 19.337C16.5165 19.3473 16.5316 19.3583 16.5459 19.3701C16.5603 19.3819 16.5742 19.3947 16.587 19.4077C16.6002 19.421 16.6126 19.435 16.6243 19.4494C16.636 19.4635 16.6472 19.4787 16.6575 19.4943C16.6677 19.5099 16.6771 19.5258 16.6857 19.5421C16.6944 19.5585 16.7023 19.5756 16.7095 19.5927C16.7162 19.6098 16.7227 19.6276 16.7279 19.6451C16.7332 19.6629 16.7381 19.6812 16.7415 19.6994C16.7453 19.7176 16.7479 19.7362 16.7497 19.7545C16.7517 19.7731 16.7527 19.7921 16.7527 19.8107C16.7527 19.8293 16.7516 19.8479 16.7497 19.8665Z"
        className="claimEmail-SVG"
      />
      <path
        d="M14.2147 2H7.52484C7.40595 2 7.30958 2.09714 7.30958 2.21698V5.74658C7.30958 5.75105 7.30901 5.75541 7.3089 5.75984C7.30901 5.76428 7.30958 5.76864 7.30958 5.77311C7.30958 6.0878 7.05649 6.34291 6.74429 6.34291H3.21526C3.09637 6.34291 3 6.44006 3 6.5599V17.1876C3 18.0748 3.71351 18.794 4.59366 18.794H10.5338C10.7805 18.794 10.9663 18.5676 10.9193 18.3235C10.8664 18.0483 10.8386 17.7639 10.8386 17.4731C10.8386 15.0211 12.8106 13.2232 15.2431 13.2232C15.2966 13.2232 15.3499 13.2242 15.403 13.2261C15.6247 13.2341 15.8084 13.0542 15.8084 12.8305V3.60641C15.8084 2.71921 15.0949 2 14.2147 2ZM8.70391 15.5209H5.82785C5.51566 15.5209 5.26257 15.2658 5.26257 14.9511C5.26257 14.6364 5.51566 14.3813 5.82785 14.3813H8.70391C9.01611 14.3813 9.2692 14.6364 9.2692 14.9511C9.2692 15.2658 9.01611 15.5209 8.70391 15.5209ZM12.9806 13.2526H5.82782C5.51562 13.2526 5.26253 12.9975 5.26253 12.6828C5.26253 12.3681 5.51562 12.113 5.82782 12.113H12.9806C13.2928 12.113 13.5459 12.3681 13.5459 12.6828C13.5459 12.9975 13.2927 13.2526 12.9806 13.2526ZM12.9806 10.9668H5.82782C5.51562 10.9668 5.26253 10.7117 5.26253 10.397C5.26253 10.0823 5.51562 9.82718 5.82782 9.82718H12.9806C13.2928 9.82718 13.5459 10.0823 13.5459 10.397C13.5459 10.7117 13.2927 10.9668 12.9806 10.9668ZM12.9806 8.76878H5.82782C5.51562 8.76878 5.26253 8.51367 5.26253 8.19898C5.26253 7.88428 5.51562 7.62917 5.82782 7.62917H12.9806C13.2928 7.62917 13.5459 7.88428 13.5459 8.19898C13.5459 8.51367 13.2927 8.76878 12.9806 8.76878Z"
        className="claimEmail-SVG"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ClaimReplySVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7 4H18.3C19.235 4 20 4.765 20 5.7V15.9C20 16.835 19.235 17.6 18.3 17.6H4.7C3.765 17.6 3 16.835 3 15.9L3.0085 5.7C3.0085 4.765 3.765 4 4.7 4ZM11.5 11.65L18.3 7.4V5.7L11.5 9.95L4.7 5.7V7.4L11.5 11.65Z"
      className="claimEmail-SVG"
    />
  </svg>
);

const ClaimSendEmailSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1564 7.44491L1.40636 0.569914C1.29859 0.516018 1.17754 0.494423 1.05778 0.507729C0.938028 0.521036 0.82467 0.568676 0.731361 0.644914C0.642251 0.719597 0.57574 0.817655 0.539304 0.928066C0.502869 1.03848 0.497953 1.15686 0.525111 1.26991L2.18136 7.37616H9.25011V8.62616H2.18136L0.500111 14.7137C0.474627 14.8081 0.471653 14.9071 0.491426 15.0029C0.511199 15.0987 0.553169 15.1885 0.61396 15.2651C0.674751 15.3417 0.752668 15.4029 0.841444 15.4439C0.930221 15.4849 1.02738 15.5045 1.12511 15.5012C1.22295 15.5006 1.31928 15.477 1.40636 15.4324L15.1564 8.55741C15.2587 8.50497 15.3447 8.42528 15.4046 8.32714C15.4646 8.22899 15.4964 8.11619 15.4964 8.00116C15.4964 7.88614 15.4646 7.77334 15.4046 7.67519C15.3447 7.57705 15.2587 7.49736 15.1564 7.44491Z"
      fill="#0A7593"
    />
  </svg>
);

export {
  ClaimsDownloadSVG,
  SendSVG,
  ClaimEmailSVG,
  ViewJobSVG,
  ClaimReplySVG,
  ClaimSendEmailSVG,
};
